/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component } from "@angular/core";
import { StackView } from "./stack-view";
var StackHeader = (function () {
    function StackHeader(stackView) {
        this.stackView = stackView;
    }
    return StackHeader;
}());
export { StackHeader };
StackHeader.decorators = [
    { type: Component, args: [{
                selector: "clr-stack-header",
                template: "\n        <h4 class=\"stack-header\">\n            <span class=\"stack-title\"><ng-content></ng-content></span>\n            \n            <span class=\"stack-actions\">\n                <ng-content select=\".stack-action\"></ng-content>\n                <!-- Undocumented experimental feature: inline editing. -->\n                <button *ngIf=\"stackView.editable\" class=\"stack-action btn btn-sm btn-link\" \n                        (click)=\"stackView.editing = !stackView.editing\" type=\"button\">\n                        Edit\n                </button>\n                <!-- End of undocumented experimental feature. -->\n            </span>\n        </h4>\n    ",
                // Custom elements are inline by default
                styles: ["\n        :host { display: block; }\n    "]
            },] },
];
/** @nocollapse */
StackHeader.ctorParameters = function () { return [
    { type: StackView, },
]; };
//# sourceMappingURL=stack-header.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/stack-view/stack-header.js
// module id = 172
// module chunks = 4